

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>






<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>




  
<div class="row"  data-aos="zoom-in" data-aos-delay="300" >
  <div class="col-md-6 text-center">
    <img style="width:70%;height: 90%;margin-top:10%;border-radius:40px;box-shadow: 50px 20px #6ab187;" src="assets/gst.jpg">
</div>
    <div style="padding-top: 10%;" class="col-md-6">
        <h1>
            <span class="topic">Real-time GST Verification </span>
          </h1>
        <h5 style="padding-left: 10%;">&nbsp;&nbsp;&nbsp;As you onboard business partners, make sure that their GST information and returns are legitimate, stop fraud, and make sure that the account holders are who they say they are.</h5>
    </div>

   
</div>
<br><br>
<br>


<div class="row"  data-aos="zoom-in" data-aos-delay="300" >
    <div class="col">
        <div style="
        margin: 0 auto;
        float: none;
        margin-bottom: 10px;
        background-color: #eff8ff;" class="card w-65">
        <div class="card-body">
            <h2 style="text-align: center;font-size: 550;color: #6ab187;">What do you require for GST <br> Verification?</h2>
        </div>
        </div>
    </div>
    </div>
    <br><br>
  
    
<div class="row p-2">

    <div   class="col-md-4"  data-aos="fade-up" data-aos-delay="300"  >
        <br>
        <img style="width: 60px;height: 65px;" src="assets/fakegst.png">
       <br><br>
        <h5 >Fake GSTIN registration</h5>
        <p style="align-items: center;">Fraudsters may obtain a fake or invalid GSTIN to portray themselves as legitimate businesses and take advantage of the GST system for fraudulent purposes.</p>
    </div>
  
    <div class="col-md-4"  data-aos="fade-up" data-aos-delay="300"  >
          <br>
          <img style="width: 70px;height: 65px;" src="assets/inputtax.png">
         <br><br>
          <h5>Input Tax Credit (ITC) fraud</h5>
          <p style="align-items: center;">Ineligible businesses may issue fake invoices or falsely claim ITC on GST paid for non-existent or fictitious transactions, leading to tax evasion.</p>
      </div>
     
      <div class="col-md-4"  data-aos="fade-up" data-aos-delay="300"  >
     
        <br>
        <img style="width: 60px;height: 60px;" src="assets/corporateidentity.png">
       <br><br>
        <h5 >Corporate Identity theft</h5>
        <p style="align-items: center;">Fraud Businesses may use someone else’s GSTIN details for conducting business transactions, leading to identity theft and misuse <p>
    </div>
  
  </div>
  
  <br><br>

<h1  data-aos="zoom-in" data-aos-delay="300" style="text-align: center;color: #6ab187;">Types of GSTIN Verification API's​</h1><br>
<h6  data-aos="zoom-in" data-aos-delay="300" style="text-align: center;color: gray;">Choose from different types of instant GSTIN API’s as per your business screening needs</h6>
<br>
<!-- verification api's -->
  <div style="background-color: azure;" class="row p-2">
    <div class="col-md-3 mt-2"  data-aos="fade-up" data-aos-delay="300" >
        <div class="card" style="height: 250px;" >
            <div class="card-body">
                <img style="width: 25%;height:25%" src="assets/gstin.png">
                <br><br>
              <h5 class="card-title">Know Your PAN using GSTIN</h5>
              <p class="card-text">Get PAN details of a Business using GSTIN number</p>
                <br>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2"  data-aos="fade-up" data-aos-delay="300" >

        <div class="card"  style="height: 250px;" >
            <div class="card-body">
                <img style="width: 25%;height:25%" src="assets/registrationcheck.png"><br>
                <br>
              <h5 class="card-title">GSTIN Registration Check</h5>
              <p class="card-text">Get complete GSTIN registration details of a Business’ using GSTIN number as input</p>
           <br>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2"  data-aos="fade-up" data-aos-delay="300" >

        <div class="card" style="height: 250px;" >
            <div class="card-body">
                <img style="width: 25%;height:25%" src="assets/gstreturnfill.jpg">
                <br><br>
              <h5 class="card-title">GSTR Return Filing details</h5>
              <p class="card-text">Consent-based service to upload Aadhaar number XML file and fetch e-Aadhaar details</p>
            <br>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2"  data-aos="fade-up" data-aos-delay="300" >

        <div class="card"  style="height: 250px;">
            <div class="card-body">
                <img style="width: 25%;height:29%" src="assets/gstdetails.png">
                  <h4 class="card-title">Comprehensive GST Details</h4>
              <p class="card-text">Complete GSTIN Details along with detailed insights on Customers, with sales and turnover details</p>
            </div>            
          </div>
    </div>
    
    <div class="col-md-3 mt-2"  data-aos="fade-up" data-aos-delay="300" >
      <div class="card"  style="height: 250px;">
          <div class="card-body">
              <img style="width: 25%;height:25%" src="assets/track.png">
              <br><br>
            <h5 class="card-title">GSTIN View and Track Return</h5>
            <p class="card-text">All GSTIN Returns view for a given financial year</p>
              <br>
          </div>            
        </div>
  </div>

  <div class="col-md-3 mt-2"  data-aos="fade-up" data-aos-delay="300" >

      <div class="card" style="height: 250px;" >
          <div class="card-body">
              <img style="width: 25%;height:25%" src="assets/taxpay.jpg"><br>
              <br>
            <h5 class="card-title">GSTIN TAXPAYER Check</h5>
            <p class="card-text">All GSTIN Taxpayer Details are provided with nature of business and jurisdiction details</p>
         <br>
          </div>            
        </div>
  </div>

  <div class="col-md-3 mt-2"  data-aos="fade-up" data-aos-delay="300" >

      <div class="card" style="height: 250px;" >
          <div class="card-body">
              <img style="width: 25%;height:25%" src="assets/linkcards.png">
              <br><br>
            <h5 class="card-title">PAN to GST Linkage Check</h5>
            <p class="card-text">PAN to GSTIN Check to fetch all GSTIN linked with a PAN number</p>
          <br>
          </div>            
        </div>
  </div>

  <div class="col-md-3 mt-2"  data-aos="fade-up" data-aos-delay="300" >

      <div class="card" style="height: 250px;" >
          <div class="card-body">
              <img style="width: 25%;height:29%;border-radius: 15px;margin-top: 20px;" src="assets/purchase2b.png">
              <br><br>
                <h5 class="card-title">GSTR Purchase 2B details</h5>
            <p class="card-text">Get all GSTR Purchase 2B details via this API</p>
            <br>
          </div>            
        </div>
  </div>

  </div>
  


  
  
  <br><br>
  
  <!-- advantage -->
  
<div class="row"  data-aos="zoom-in" data-aos-delay="300"  >
    <div class="col">
        <div style="
        margin: 0 auto;
        float: none;
        margin-bottom: 10px;" class="card w-65">
        <div class="card-body">
            <h2 style="text-align: center;font-size: 550;color: #6ab187;">FaCheck's GST Verification API's Advantages</h2>
        </div>
        </div>
    </div>
    </div>
    <br><br><br>
  
     
  <div class="row p-2">
  
    <div   class="col-md-3"  data-aos="fade-up" data-aos-delay="300" >
        <br>
        <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/activestatus.jpg">
       <br><br><br>
        <h5 >GSTIN Active Status</h5>
        <p style="align-items: center;">Enter the provided GSTIN number and verify if the provided account is active and valid.</p>
    </div>
  
    <div style="background-color: #c9d9e6;" class="col-md-3"  data-aos="fade-up" data-aos-delay="300" >
          <br>
          <img style="width: 70px;height: 80px;" src="assets/gstfiling.png">
         <br><br>
          <h5 >GST Filing Details</h5>
          <p style="align-items: center;">Verify GST numbers, Status, Taxpayer types, and state bifurcation. Provides all the locations of operations (main and support).</p>
      </div>
     
      <div  style="background-color: #eff8ff;" class="col-md-3"  data-aos="fade-up" data-aos-delay="300" >
     
        <br>
        <img style="width: 60px;height: 60px;" src="assets/credibility.png">
       <br><br><br>
        <h5 >Credibility Analysis</h5>
        <p style="align-items: center;">Dig deeper with details like mode of filing and return type bifurcation for further analysis.<p>
    </div>
    <div style="background-color: #c9d9e6;" class="col-md-3"  data-aos="fade-up" data-aos-delay="300" >
     
      <br>
      <img style="width: 60px;height: 60px;" src="assets/plugplay.png">
     <br><br><br>
      <h5 >Plug & Play API's</h5>
      <p style="align-items: center;">Digitize and scale your operations with easy to activate, simple to use data exchange mechanisms via our plug and play APIs.<p>
  </div>
  
  
  </div>
  
  
  <br><br><br><br>
  
  
  <!-- faq -->
  <div  data-aos="zoom-in" data-aos-delay="300" class="faq-title text-center pb-3">
    <h2>FAQ</h2>
</div>


<div class="row"  data-aos="fade-up" data-aos-delay="300" >

  <div id="slide" style="margin-top: 20%;" class="col-md-6">
    <h1 style="text-align: center;color: #6ab187;">FACheck's FAQ</h1>
   </div>
    <div class="col-md-6">
        <div style="width: 90%;" class="faq-content">
            <div class="faq-question">
              <input id="q1" type="checkbox" class="panel">
             
              <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q1" class="panel-title"> &nbsp;&nbsp; What is a GST Identification Number (GSTIN)/GST Number?</label>
              <div class="panel-content">GSTIN or Goods and Services Tax Identification Number is a unique 15-digit alpha-numeric PAN-based code allotted to every registered person under Goods and Service Tax.
                This number is provided to the GST taxpayer along with the GST registration certificate. This unique number allows tracking of a registered taxpayer.</div>
            </div>
            
            <div class="faq-question">
              <input id="q2" type="checkbox" class="panel">
              <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q2" class="panel-title">&nbsp;&nbsp; Why do we need a GST number? </label>
              <div class="panel-content">GSTIN or Goods and Services Tax Identification Number is a unique 15-digit alpha-numeric PAN-based code allotted to every registered person under Goods and Service Tax. 
                This number is provided to the GST taxpayer along with the GST registration certificate. This unique number allows tracking of a registered taxpayer. </div>
            </div>
            
            <div class="faq-question">
              <input id="q3" type="checkbox" class="panel">
              <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q3" class="panel-title">&nbsp;&nbsp; What is a GST Verification API?</label>
              <div class="panel-content">Since every entity registered under GST is provided with a unique 15-digit identification number from the concerned tax authorities, it is used for collecting tax on behalf of the government and accessing input tax credits.A GSTIN number can also be used to perform GST verification in order to validate the authenticity of a registered company or business. 
                 </div>
            </div>
        
            <div class="faq-question">
                <input id="q4" type="checkbox" class="panel">
                
               <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
                <label for="q4" class="panel-title">&nbsp;&nbsp; Why Should Businesses Leverage the GST Verification API?</label>
                <div class="panel-content">A GST Verification API is an API enabling businesses to complete KYB by verifying a registered company’s GSTIN number. The API typically accepts the GSTIN as the API request and responds with validated data such as the GSTIN, Business Name, Constitution of Business, Address, GSTR returns, update status, nature of business and other details for accurate verification of a Business </div>
              </div>

              <div class="faq-question">
                <input id="q5" type="checkbox" class="panel">
                <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
                <label for="q5" class="panel-title">&nbsp;&nbsp;What attributes can we verify using GST Verification API?</label>
                <div class="panel-content">The API typically accepts the GSTIN as the API request and responds with validated data such as the GSTIN, Business Name, Constitution of Business, Address, and so forth</div>
              </div>
             
              <div class="faq-question">
                <input id="q6" type="checkbox" class="panel">
                <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
                <label for="q6" class="panel-title">&nbsp;&nbsp;How does the GST verification API work? </label>
                <div class="panel-content">To use the GST Verification API, you will need to obtain an API key from the GST Portal, which is the official website for GST in India. You can then use this API key to access the GST Verification API and retrieve information about the GST registration status of a business. </div>
              </div>
             
              <div class="faq-question">
                <input id="q7" type="checkbox" class="panel">
                <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
                <label for="q7" class="panel-title">&nbsp;&nbsp;What programming languages does it support?  </label>
                <div class="panel-content">The GST Verification API can be accessed using any programming language that supports HTTP requests, such as Python, Java, or C#. There are also a number of third-party tools and libraries that can be used to make it easier to access the API and retrieve the information that you need.</div>
              </div>
             
          </div>
    </div>


</div>


 





